export default function ({ className = "", phone = "" }) {
  return (
    <a className={className} href={`tel:${phone.replace(/[^0-9]/g, "")}`}>
      {phone}
    </a>
  );
}
